import clientLocalStorage from "@/stores/ClientLocalStorage";

const clientService = {
  async saveToLocalStorage(clientModel) {
    clientLocalStorage.saveClient(clientModel.serialize());
  }
}

export default clientService;